export default __webpack_public_path__ + "static/media/portadavideoplanificacion7.a17cef0d.png";